package com.dotpx.ambient

import kotlin.math.PI
import kotlin.math.sin

/** Evaluates slow sine controls once per block and linearly interpolates intermediate samples. */
internal class InterpolatedSineControl(private val sampleRate: Double) {
    private var phase = 0.0
    private var phaseStep = 0.0
    private var value = 0.0
    private var valueStep = 0.0
    private var framesRemaining = 0

    init {
        require(sampleRate.isFinite() && sampleRate > 0.0) { "sampleRate must be finite and positive" }
    }

    fun reset(phaseRadians: Double, frequency: Double) {
        phase = wrapPhase(phaseRadians)
        phaseStep = 2.0 * PI * frequency.coerceAtLeast(0.0) / sampleRate
        value = sin(phase)
        valueStep = 0.0
        framesRemaining = 0
    }

    fun next(): Float {
        if (framesRemaining == 0) {
            phase = wrapPhase(phase + phaseStep * CONTROL_INTERVAL_FRAMES)
            val target = sin(phase)
            valueStep = (target - value) / CONTROL_INTERVAL_FRAMES
            framesRemaining = CONTROL_INTERVAL_FRAMES
        }
        value += valueStep
        framesRemaining -= 1
        return value.toFloat()
    }

    private fun wrapPhase(value: Double): Double {
        val cycle = PI * 2.0
        return value - kotlin.math.floor(value / cycle) * cycle
    }

    private companion object {
        const val CONTROL_INTERVAL_FRAMES = 32
    }
}
